import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import FavoriteIcon from '@mui/icons-material/Favorite';
import { FloatingButton } from "../utils/IconButton";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CustomDivider from "../utils/CustomDivider";
import { Main_URL } from "../constants";


const SkillBoxProductCard = ({ item }) => {
    return (
        <Card
            sx={{ boxShadow: "none" }}
        >
            <CardContent
                sx={{
                    position: "relative",
                    height: "218px",
                    backgroundImage: `url(${`https://myskill.club/shop/uploads/images/${item?.image_small}`})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                    overflow: "hidden",
                    boxShadow: "none",
                    cursor: "pointer"

                }}
                onClick={() => {
                    window.open(`${Main_URL}/shop/${item?.slug}`, "_blank");
                }}
            >
                <FloatingButton icon={<FavoriteIcon
                    style={{
                        fontSize: '15px',
                        color: '#fff'
                    }}
                />}
                    bgcolor={"rgba(0, 0, 0, 0.65)"}
                    sx={{ right: 5, top: 5, p: "5px" }}
                />
            </CardContent>

            <CardContent
                sx={{
                    border: "1px solid #E7E7E7",
                    background: "#FFFFFF",
                    px: "1rem",
                    borderBottomLeftRadius: "15px",
                    borderBottomRightRadius: "15px",
                }}
            >
                <Box sx={{ my: "1rem" }}>
                    <Typography variant="body1">
                        {item?.course_name}
                    </Typography>
                    <CustomDivider size={"0.5rem"} />
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",


                    }}>
                        {/* <CustomButtonContained
                            buttonText="Shop Now"
                            onClick={() => {
                                window.open(`https://myskill.club/shop/${item?.slug}`, "_blank");
                            }}
                        /> */}
                        <Button
                            variant={"contained"}
                            onClick={() => {
                                window.open(`${Main_URL}shop/${item?.slug}`, "_blank");
                            }}
                        >
                            Shop Now
                        </Button>
                        <Typography variant="body1" sx={{ display: "flex", alignItems: "center" }}>
                            <CurrencyRupeeIcon sx={{ color: "red.main", fontSize: "20px" }} /> {item?.price}
                        </Typography>




                    </Box>
                </Box>


            </CardContent>
        </Card>
    )
}

export default SkillBoxProductCard
